import React, {useEffect, useState} from "react";
import { isMobile } from "../common/viewBreakpoints";
import SignIn from './SignIn';
import SignUp from './signup/index';
import queryString from "query-string";

import {
  useLocation
} from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import * as userActions from "../../redux/actions/userActions";
import { bindActionCreators } from "redux";
import PropTypes from 'prop-types';
import { connect } from "react-redux";

const SignInWidget = ({hideUserMsg, countryCode, industryId, showGoBackButton, titleText, defaultEmail, googleAnalyticsPrefixText }) => {
  let location = useLocation();

  let googleAnalyticsParentPath = googleAnalyticsPrefixText ? googleAnalyticsPrefixText : null;

  const isMobileDevice = isMobile(useMediaQuery);

  const parsed = queryString.parse(location.search);
  
  const splitAnyUrlParams = parsed?.from?.split("?");
  const convertToURLParamFormat = splitAnyUrlParams && `?${splitAnyUrlParams[1]}`;
  const urlParams = new URLSearchParams(convertToURLParamFormat);
  const emailInURLParam = urlParams.get("email");
  const trackPageViews = emailInURLParam!=null; //shouldn't track widget steps if we have email in url param - we'll go to them automatically

  const [stage, setStage] = useState('signin');
  const resolvedDefaultEmail = parsed.email || emailInURLParam || defaultEmail || "";

  return (
    <div className={`old-styles ${isMobileDevice && 'w-100'}`}>
      {
        {
          'signin': <SignIn trackPageViews={trackPageViews} isMobileDevice={isMobileDevice} googleAnalyticsParentPath={googleAnalyticsParentPath} defaultEmail={resolvedDefaultEmail} onSwitchToSignUp={() => setStage('signup')} />,
          'signup': <SignUp trackPageViews={trackPageViews} handleGoBack={() => setStage('signin')} countryCode={countryCode} industryId={industryId} showGoBackButton={showGoBackButton} titleText={titleText} isMobileDevice={isMobileDevice} googleAnalyticsParentPath={googleAnalyticsParentPath} defaultEmail={resolvedDefaultEmail} />
        }[stage]
      }
      </div>
  );
};

SignInWidget.propTypes = {
  defaultEmail: PropTypes.string
};

function mapStateToProps(state) {
  const userExistsWithLogins = state.user && state.user.loginMethods && state.user.loginMethods.length>0;
  let userDoesNotExistOrNoLogins;

  if(!userExistsWithLogins){
    userDoesNotExistOrNoLogins = state.user && (
      (state.user.error && state.user.error.status === 404) || 
      (state.user.loginMethods && state.user.loginMethods.length==0)
      );
  }

  return {
    userExistsWithLogins: userExistsWithLogins,
    userDoesNotExistOrNoLogins: userDoesNotExistOrNoLogins,
    cognitoGuest: state.cognitoGuest
  };
}

const mapDispatchToProps = (dispatch) => ({
  actions: {
    verifyUserExists: bindActionCreators(
      userActions.doesUserExist,
      dispatch
    )
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(SignInWidget);
